export const apificate = (state) => {
  return state.list.map(document => {
    let assignmentDocuments = {}
    assignmentDocuments.documentCharacter = document.documentNature
    assignmentDocuments.representationIdentity = document.representationType
    assignmentDocuments.documentType = document.documentType
    let repository = {}
    repository.repositoryName = document.repositoryName
    repository.url = document.url
    repository.reference = document.reference
    assignmentDocuments.repository = repository
    return assignmentDocuments
  })
}

export const getDetails = (state) => {
  return state.list.map((document) => {
    return {
      document,
      _showDetails: false
    }
  })
}

export const getDocumentList = (state) => {
  return state.list
}

export const getDocumentByKey = state => key => {
  return state.list.find(document => document.key === key)
}
